export default {
  "settlementPending": "La confirmación del pago está pendiente. Actualiza tu cuenta o vuelve a comprobarlo en unos instantes antes de reintentar.",
  "checkoutOpenFailed": "No se ha podido abrir el pago seguro. Inténtalo de nuevo.",
  "checkoutClosed": "Se ha cerrado el pago. La confirmación puede seguir pendiente. Comprueba el resultado antes de reintentar.",

  "returnToApp": "Volver a la app",
  "dashboard": "Inicio",
  "account": "Cuenta",
  "currentBalance": "Saldo actual",
  "balanceUnavailable": "Saldo no disponible",
  "balanceLoading": "Cargando saldo",
  "lastUpdated": "Última actualización",
  "monthlyBillHelp": "Estos cargos se incluirán en tu factura mensual.",
  "billingPeriod": "Periodo de facturación",
  "currentMonth": "Mes actual",
  "billableItems": "Conceptos facturables",
  "payBalance": "Pagar el saldo actual",
  "settleHelp": "Paga tu saldo actual de forma segura en línea.",
  "autoRefreshHelp": "Actualizaremos tu saldo automáticamente cuando se confirme el pago.",
  "retry": "Reintentar",
  "noCharges": "No tienes cargos pendientes.",
  "clearHelp": "Tu cuenta no tiene cargos en el periodo de facturación actual.",
  "statementItems": "Conceptos del extracto actual",
  "includedThisMonth": "Incluidos en la factura de este mes",
  "preparingCheckout": "Preparando el pago seguro…",
  "paymentsDisabled": "Los pagos en línea aún no están habilitados para este club.",
  "paymentsSetup": "El club está configurando los pagos en línea.",
  "paymentReceived": "Pago recibido. El saldo de tu cuenta está actualizado.",
  "statementUpdating": "Pago recibido. Se está actualizando tu extracto.",
  "paymentCancelled": "Se ha cancelado el pago. No se ha realizado ningún cobro.",
  "allowPopups": "Permite las ventanas emergentes para abrir el pago seguro en una pestaña nueva.",
  "checkoutOpened": "El pago seguro se ha abierto en una pestaña nueva.",
  "checkoutFailed": "No se ha podido preparar el pago seguro. Inténtalo de nuevo en unos instantes.",
  "items": "{count} concepto",
  "itemsMany": "{count} conceptos",
  "refreshing": " · Actualizando",
  "loadFailed": "No se ha podido cargar tu saldo. Inténtalo de nuevo.",
  "unknownStatus": "Estado no disponible",
  "noBalanceDue": "No hay saldo pendiente.",
  "balanceUnconfirmed": "No se ha podido confirmar tu saldo actual. Actualiza tu cuenta.",
  "currencyUnavailable": "La moneda del pago en línea no está disponible. Contacta con el club."
}
